import { Typography } from "@mui/material";

interface PageTitleProps {
  children: React.ReactNode;
}

export default function PageTitle({ children }: PageTitleProps) {
  return (
    <Typography
      fontWeight="bold"
      sx={{
        fontSize: 36,
        color: "primary.main",  // Uses #007300 from your theme
        textAlign: "left",
        p: 1,
        pb: 2.5,
      }}
    >
      {children}
    </Typography>
  );
}